import React, { useEffect, useState } from "react";
import SumsubWebSdk from "@sumsub/websdk-react";
import Axios from "../../../../config/axios";
import { UrlConstant } from "../../../../commom/UrlConstant";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import BoltIcon from '@mui/icons-material/Bolt';
import ArticleIcon from '@mui/icons-material/Article';
import CardImg from '../../../../commom/Assets/images/Card.png';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from "react-router-dom";
import { getUserFromLocalStorage } from "../../../../utils/utils";

function SumSubKYC() {
  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [isKYCVerified, setIsKYCVerified] = useState(false);
  const navigate = useNavigate();
  const user = getUserFromLocalStorage();

  const checkAccountStatus = async () => {
    try {
        const response = await Axios.get(
            UrlConstant.TradingAccount.CheckAccountStatusV2
        );
        const resData = response.data;
        if (resData.status === true) {
          setIsKYCVerified(resData.data.kyc_verified)
        }
    } catch (error) {
        console.error("ERRR : ", error);
    }
    finally {
        setLoading(false)
    }
  };

useEffect(() => {
  checkAccountStatus()
}, [])

  // Config and options for the SDK
  const config = {
    lang: "en",
    theme: "dark",
    // Add other config options as needed
  };
  const options = {
    // Add any SDK options here if needed
  };

  // Handler for token expiration (fetch a new token and update state)
  const accessTokenExpirationHandler = async (cb) => {
    try {
      const response = await Axios.post(UrlConstant.Crypto.getSumSubAccessToken);
      const token = response.data?.token || response.data?.accessToken || response.data?.data?.token;
      if (!token) throw new Error("No access token returned from API");
      setAccessToken(token);
      cb(token);
    } catch (err) {
      setError("Failed to refresh KYC access token");
      cb(null);
    }
  };

  // Handler for SDK messages
  const messageHandler = (type, payload) => {
    if (type === "finished") setOpen(false);
    console.log("Sumsub event:", type, payload);
  };

  // Handler for SDK errors
  const errorHandler = (err) => {
    console.error("Sumsub error:", {err});
    setError("Sumsub SDK error: " + (err?.message || err));
  };

  const startKYC = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await Axios.post(UrlConstant.Crypto.getSumSubAccessToken);
      const token = response.data?.token || response.data?.accessToken || response.data?.data?.token;
      if (!token) throw new Error("No access token returned from API");
      setAccessToken(token);
      setOpen(true);
    } catch (err) {
      setError("Failed to fetch KYC access token");
    } finally {
      setLoading(false);
    }
  };

  const handleEConsentClick = () => {
    navigate("/e-consent", { state: user });
  };

  const handleClose = () => setOpen(false);

  // E-Consent Card Component
  const EConsentCard = () => {
    if (user?.econsentAccepted) {
      return null;
    }
    // E-Consent Card Component (orange theme, animated)
  // const cardAnimation = {
  //   animation: 'cardGlow 2.5s ease-in-out infinite',
  // };
  const iconAnimation = {
    animation: 'iconBounce 2.0s cubic-bezier(.68,-0.55,.27,1.55) infinite',
    willChange: 'transform',
  };
    return (
      <div
        style={{
          background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', // dark blue/gray
          borderRadius: 28,
          padding: '42px 24px 24px 24px',
          color: '#fff',
          textAlign: 'center',
          maxWidth: 420,
          margin: '32px auto',
          // boxShadow: '0 4px 32px 0 rgba(242,103,74,0.18)',
          position: 'relative',
          // ...cardAnimation,
        }}
      >
        <style>{`
          @keyframes cardGlow {
            0%, 100% { box-shadow: 0 4px 32px 0 rgba(242,103,74,0.18); }
            50% { box-shadow: 0 8px 40px 0 #f2674acc; }
          }
          @keyframes iconBounce {
            0%, 100% { transform: translateY(0); }
            20% { transform: translateY(-10px) scale(1.08); }
            40% { transform: translateY(0); }
            60% { transform: translateY(-6px) scale(1.04); }
            80% { transform: translateY(0); }
          }
        `}</style>
        <ArticleIcon
          style={{
            fontSize: 68,
            marginBottom: 18,
            color: 'rgb(242,103,74)',
            filter: 'drop-shadow(0 2px 12px #fcb118aa)',
            ...iconAnimation,
          }}
        />
        <div
          style={{
            fontSize: 25,
            fontWeight: 700,
            marginBottom: 12,
            lineHeight: 1.3,
            letterSpacing: 0.1,
            textShadow: '0 2px 8px #fcb11855',
          }}
        >
          Complete Electronic<br />Records Consent
        </div>
        <div
          style={{
            fontSize: 16,
            opacity: 0.92,
            marginBottom: 24,
            lineHeight: 1.4,
            color: '#fff',
          }}
        >
          Accept electronic communications to access all Wolfpack services and features
        </div>
        <button
          style={{
            background: 'linear-gradient(90deg, rgb(242,103,74) 0%, #fcb118 100%)',
            color: '#fff',
            border: 'none',
            borderRadius: 32,
            padding: '16px 0',
            fontSize: 18,
            fontWeight: 700,
            width: '100%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            // boxShadow: '0 2px 12px #fcb11855',
            transition: 'all 0.2s cubic-bezier(.68,-0.55,.27,1.55)',
          }}
          onClick={handleEConsentClick}
          onMouseOver={e => {
            e.target.style.transform = 'scale(1.04)';
            // e.target.style.boxShadow = '0 6px 24px #fcb118aa';
          }}
          onMouseOut={e => {
            e.target.style.transform = 'scale(1)';
            // e.target.style.boxShadow = '0 2px 12px #fcb11855';
          }}
        >
          Review & Accept
          <ArticleIcon style={{ fontSize: 22, color: '#fff', marginLeft: 2 }} />
        </button>
      </div>
    );
  };

  // KYC Card Component
  const KYCCard = () => (
    <div style={{
      background: '#4A7AF2B2',
      borderRadius: 28,
      padding: '42px 24px 24px 24px',
      color: 'white',
      textAlign: 'center',
      maxWidth: 420,
      margin: '32px auto',
      boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
      position: 'relative',
    }}>
      <img src={CardImg} alt="KYC Card" style={{ width: 120, marginBottom: 18 }} />
      <div style={{ fontSize: 24, fontWeight: 600, marginBottom: 12, lineHeight: 1.3 }}>
        Verify your KYC to enjoy<br />seamless access Crypto
      </div>
      {isKYCVerified ? (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          background: '#E6F9ED',
          color: '#22C55E',
          borderRadius: 32,
          padding: '12px 28px',
          fontWeight: 600,
          fontSize: 18,
          margin: '24px 0 0 0',
        }}>
          <CheckCircleIcon style={{ color: '#22C55E', fontSize: 28 }} />
          Verified
        </div>
      ) : (
        <button
          style={{
            background: '#4A7AF2',
            color: 'white',
            border: 'none',
            borderRadius: 32,
            padding: '16px 0',
            fontSize: 20,
            fontWeight: 500,
            width: '100%',
            margin: '24px 0 0 0',
            cursor: loading ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
          }}
          onClick={startKYC}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Get Started'}
          <BoltIcon style={{ fontSize: 24, marginLeft: 4 }} />
        </button>
      )}
      {error && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
    </div>
  );

  return (
    <>
      {/* E-Consent Card - Shows only if not accepted */}
      <EConsentCard />
      
      {/* KYC Card - Always shows */}
      {/* <KYCCard /> */}

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <div style={{ position: "relative" }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: "absolute", right: 8, top: 8, color: "#fff", zIndex: 1 }}
          >
            <CloseIcon />
          </IconButton>
          {accessToken && (
            <SumsubWebSdk
              accessToken={accessToken}
              expirationHandler={accessTokenExpirationHandler}
              config={config}
              options={options}
              onMessage={messageHandler}
              onError={errorHandler}
            />
          )}
        </div>
      </Dialog>
    </>
  );
}

export default SumSubKYC;